import Plausible from "@/Integrations/Plausible";
import Sentry from "@/Integrations/Sentry";

const Integrations = { Sentry, Plausible };

export default Integrations;
